import { getIsPadWidth } from '@elem/utils/devices';
import styles from './index.module.scss';

export default function TheComp({ title }: { title: string }) {
    const isPad = getIsPadWidth();
    const ICON_PC = () => (
        <svg className="TimerTips-icon" xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.3259 3.17463C15.579 1.42775 13.1658 0.347168 10.5005 0.347168C7.83519 0.347168 5.42199 1.42775 3.67511 3.17463C1.92823 4.9215 0.847656 7.3347 0.847656 10C0.847656 12.6653 1.92823 15.0785 3.67511 16.8254C5.42199 18.5723 7.83519 19.6528 10.5005 19.6528C13.1658 19.6528 15.579 18.5723 17.3259 16.8254C19.0727 15.0785 20.1533 12.6653 20.1533 10C20.1533 7.3347 19.0727 4.9215 17.3259 3.17463ZM11.3133 5.26673C11.3133 4.81779 10.9494 4.45386 10.5005 4.45386C10.0515 4.45386 9.68759 4.81779 9.68759 5.26673V11.3633C9.68759 11.645 9.83346 11.9066 10.0731 12.0547C10.3128 12.2028 10.612 12.2163 10.864 12.0903L14.9283 10.0581C15.3299 9.85736 15.4926 9.36909 15.2919 8.96755C15.0911 8.56601 14.6028 8.40326 14.2013 8.60403L11.3133 10.048V5.26673Z"
                fill="#FCAB0D"
            />
        </svg>
    );
    const ICON_PAD = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5509 2.44601C10.3863 1.28142 8.77752 0.561035 7.00065 0.561035C5.22378 0.561035 3.61499 1.28142 2.4504 2.44601C1.28582 3.61059 0.56543 5.21939 0.56543 6.99626C0.56543 8.77313 1.28582 10.3819 2.4504 11.5465C3.61499 12.7111 5.22378 13.4315 7.00065 13.4315C8.77752 13.4315 10.3863 12.7111 11.5509 11.5465C12.7155 10.3819 13.4359 8.77313 13.4359 6.99626C13.4359 5.21939 12.7155 3.61059 11.5509 2.44601ZM7.54249 3.60938C7.54249 3.31009 7.29986 3.06746 7.00057 3.06746C6.70128 3.06746 6.45866 3.31009 6.45866 3.60938V7.67373C6.45866 7.86155 6.55591 8.03597 6.71567 8.13471C6.87544 8.23345 7.07494 8.24243 7.24292 8.15843L9.95249 6.80365C10.2202 6.6698 10.3287 6.34429 10.1948 6.07659C10.061 5.8089 9.73548 5.7004 9.46779 5.83424L7.54249 6.7969V3.60938Z"
                fill="#FAE523"
            />
        </svg>
    );
    return (
        <div className={styles.TheComp}>
            {isPad ? <ICON_PAD /> : <ICON_PC />}
            {title}
        </div>
    );
}
